module.exports = __webpack_public_path__ + "img/live_tab_icon.89597b1a.png";